export default function MyMentor(props: any) {
  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.66992 15.3344C2.66992 13.9194 3.232 12.5625 4.23251 11.5619C5.23301 10.5614 6.58999 9.99936 8.00492 9.99936C9.41985 9.99936 10.7768 10.5614 11.7773 11.5619C12.7778 12.5625 13.3399 13.9194 13.3399 15.3344H12.0062C12.0062 14.2732 11.5846 13.2554 10.8342 12.505C10.0839 11.7547 9.06612 11.3331 8.00492 11.3331C6.94372 11.3331 5.92599 11.7547 5.17561 12.505C4.42523 13.2554 4.00367 14.2732 4.00367 15.3344H2.66992ZM8.00492 9.33249C5.79423 9.33249 4.00367 7.54193 4.00367 5.33124C4.00367 3.12055 5.79423 1.32999 8.00492 1.32999C10.2156 1.32999 12.0062 3.12055 12.0062 5.33124C12.0062 7.54193 10.2156 9.33249 8.00492 9.33249ZM8.00492 7.99874C9.47872 7.99874 10.6724 6.80503 10.6724 5.33124C10.6724 3.85744 9.47872 2.66374 8.00492 2.66374C6.53113 2.66374 5.33742 3.85744 5.33742 5.33124C5.33742 6.80503 6.53113 7.99874 8.00492 7.99874Z"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke={props.color ?? "white"}
      />
    </svg>
  )
}
